
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subsetsSearch",
      function () {
        return require("private-next-pages/subsetsSearch.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subsetsSearch"])
      });
    }
  